import { connect } from "react-redux";

import { getCartCurrency } from "@app/modules/checkout/store/v2/selectors/get-cart-currency";
import { getCartItemsTripId } from "@app/modules/checkout/store/v2/selectors/get-cart-items-trip-ids";
import { getSourceNamesForAllSegments } from "@app/modules/checkout/store/v2/selectors/get-source-names-for-all-segments";
import { getTripFareSummaryDepartures } from "@app/modules/checkout/store/v2/selectors/get-trip-fare-summary-departures";
import { getTripOperatorPerLegByTripId } from "@app/modules/checkout/store/v2/selectors/get-trip-operators";
import { getCart } from "@app/modules/checkout/store/v2/selectors/state-accessors";
import { getCartV2TripItem } from "@app/modules/checkout/utils/cart-v2";
import type { CheckoutReduxStateV2 } from "@app/types/checkout-v2-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import type { OwnProps, RefreshedCartCharges } from "./checkout-price-changed";
import type { ConnectedProps } from "react-redux";

import { CheckoutPriceChangedComponent } from "./checkout-price-changed";

const mapStateToProps =
  () =>
  (state: CheckoutReduxStateV2 & ResultsReduxState, own_props: OwnProps) => {
    const cart = getCart(state);
    const trip_id = getCartItemsTripId(state);
    const currency = getCartCurrency(state);

    const charges = own_props.refreshed_cart_charges as RefreshedCartCharges;
    const operators_per_leg = getTripOperatorPerLegByTripId(state, trip_id);
    const departures_summary = getTripFareSummaryDepartures(
      state,
      trip_id,
      charges.items!
    );
    const source_names = getSourceNamesForAllSegments(state);
    const cart_trip_item = getCartV2TripItem(cart.items);

    const passenger_first_names =
      cart_trip_item?.passengers.map(passenger => passenger.first_name || "") ||
      [];

    return {
      currency,
      // Adjust with the new charges and everything
      departures: departures_summary,
      // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      operators_name: operators_per_leg.flat().map(operator => operator.name),
      charges_total: cart.charges.total,
      initial_discount_code: null,
      passenger_first_names: passenger_first_names,
      source_names
    };
  };

const connector = connect(mapStateToProps);
export type ConnectorProps = ConnectedProps<typeof connector>;

export const CheckoutPriceChanged = connector(CheckoutPriceChangedComponent);
